import { useMemo } from "react";
import { useAuth } from "../../API/auth";

export const useUserData = () => {
  const payload = useAuth((state) => state.accessTokenPayload);
  const customerId = payload?.customer_id as number;

  return useMemo(
    () => ({
      isAgromanagerUser: payload?.sso_provider?.provider_name === "agromanager",
      isAurea: payload?.type === "aurea",
      isReseller: payload?.type === "reseller",
      type: payload?.type,
      customerId,
    }),
    [payload],
  );
};
